import * as React from 'react';
import { Component } from 'react';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Alert from '@material-ui/lab/Alert';

const styles = (theme: Theme) => createStyles({
    root: {
        flexGrow: 1,
        zIndex: 1,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        width: '100%',
        padding: '0'
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    buttonItem: {
        marginTop: theme.spacing(2),
    },
    button: {
    },
});

interface IPhotoSubmittedProps {
    returnToDocType: () => void;
    viewBasket: () => void;
    basketDocumentCount: number;
}

interface IPhotoSubmittedState {
}

export class PhotoSubmitted extends Component<IPhotoSubmittedProps & WithStyles<typeof styles>, IPhotoSubmittedState> {
    constructor(props) {
        super(props);

        this.state = {
        }
    }


    public render() {
        return (
            <Grid container>
                <Grid item xs={12}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography variant="h2">
                                Secure Document Management
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>                
                <Grid item xs={12}>
                    <Alert severity="success">Thank you, your Student Photo has now been uploaded.</Alert>
                    {this.props.basketDocumentCount === 0 ?
                        <React.Fragment>
                            <Typography>If you have nothing else to upload please close this window.</Typography>
                            <Typography>Alternatively, click on Upload Another Document to add more documents, or click on View Basket to see the documents uploaded but not yet submitted.</Typography>
                        </React.Fragment>
                        :
                        <React.Fragment>
                            <Alert severity="warning">You still have {this.props.basketDocumentCount} documents in the basket that have not yet been uploaded.</Alert>
                            <Typography>Click on Upload Another Document to add more documents, or click on View Basket to see the documents uploaded but not yet submitted.</Typography>
                        </React.Fragment>
                    }
                    
                </Grid>
                <Grid container justify="center" alignItems="center" spacing={1}>
                    <Grid item xs={12} sm={6} md={6} className={this.props.classes.buttonItem}>
                        <Button onClick={this.props.returnToDocType} color="primary" variant="contained" className={this.props.classes.button} fullWidth>
                            Upload Another Document
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} className={this.props.classes.buttonItem}>
                        <Button onClick={this.props.viewBasket} color="primary" variant="contained" className={this.props.classes.button} fullWidth>
                            View Basket
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

export default withStyles(styles)(PhotoSubmitted);

